import { Separator } from '@/components/ui/separator';

export function SeparatorSection() {
  return (
    <div className='mb-8'>
      <div className='text-center mb-4'>
        <h3 className='text-lg font-semibold'>Separator</h3>
        <p className='text-sm text-muted-foreground'>Visual dividers</p>
      </div>
      <div className='space-y-4'>
        <div>
          <div className='space-y-1'>
            <h4 className='text-sm font-medium leading-none'>Radix Primitives</h4>
            <p className='text-sm text-muted-foreground'>An open-source UI component library.</p>
          </div>
          <Separator className='my-4' />
          <div className='flex h-5 items-center space-x-4 text-sm'>
            <div>Blog</div>
            <Separator orientation='vertical' />
            <div>Docs</div>
            <Separator orientation='vertical' />
            <div>Source</div>
          </div>
        </div>
      </div>
    </div>
  );
}
